<template>
  <div :id="questionId" :name="name" class="questionModel pb-3">
    <b-button v-b-toggle="questionId" block :class="buttonClass" :style="buttonStyle"
      ><div class="buttonText" :style="buttonTextColor">{{ label }}</div>
      <b-icon v-if="helpText" :style="buttonTextColor" class="mt-1" :icon="icon" />
    </b-button>
    <b-collapse v-if="helpText" :id="questionId" v-model="visible">
      <b-card style="background: #F7F7F7;"
        ><span class="textInsideStyle" v-html="helpText"></span
      ></b-card>
    </b-collapse>
  </div>
</template>
<script>
  export default {
    name: 'SubSection',
    props: ['label', 'name', 'helpText', 'questionId'],
    data() {
      return {
        visible: this.helpText !== undefined,
        buttonClass: this.helpText !== undefined ? 'mt-3 test' : 'mt-3 test pointerEventsNone',
      };
    },
    computed: {
      buttonStyle() {
        return this.visible
          ? 'background: #585df3; border-radius: 8px 8px 0px 0px;'
          : 'background: rgba(0, 0, 201, 0.05);border-radius: 4px;';
      },
      buttonTextColor() {
        return this.visible ? 'color: #FCFCFC;' : 'color: #1C1C1C;';
      },
      icon() {
        return this.visible ? 'chevron-up' : 'chevron-down';
      },
    },
  };
</script>
<style scoped>
  .buttonText {
    font-weight: 600;
    font-size: 16px;
    line-height: 24px;
  }
  .textInsideStyle {
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
    color: #3d3d3d;
  }
  .test {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
  }
  .pointerEventsNone {
    pointer-events: none;
  }
</style>
